import { CalendarPlanThemeLink } from '@yandex-int/k-common';
import { CalendarPlanWithThemes } from '@yandex-int/k-common/client/api/defs/get-calendar-plan-with-themes';
import b from 'b_';
import { SimpleCallback } from 'platform-components';
import React, { useMemo } from 'react';
import { useMedia } from 'react-use';

import { CalendarPlanThemeCard } from '../__theme-card/calendar-plan__theme-card';
import { MEDIA_QUERY_MOBILE, MEDIA_QUERY_TABLET } from '../../library.calendar-plan/constants';
import { UploadPlanButton } from '../../library.uplodad-plan-button/upload-plan-button';

interface Props {
    calendarPlan: CalendarPlanWithThemes;
    onUploadCalendarPlan: SimpleCallback;
    onThemeClick: (themeId: string) => void;
}

export const CalendarPlanThemeList = (props: Props) => {
    const { calendarPlan, onUploadCalendarPlan, onThemeClick } = props;
    const isMobile = useMedia(MEDIA_QUERY_MOBILE);
    const isTablet = useMedia(MEDIA_QUERY_TABLET);

    let groupCount = useMemo(() => {
        if (isMobile) {
            return 1;
        }

        if (isTablet) {
            return 2;
        }

        return 4;
    }, [isMobile, isTablet]);

    const groups = useMemo(() => {
        const items = [...calendarPlan.themes_with_periods];
        const groupedThemes: CalendarPlanThemeLink[][] = new Array(groupCount);

        for (let i = 0; i < groupCount; i += 1) {
            const chunkSize = Math.ceil(items.length / (groupCount - i));
            groupedThemes[i] = items.splice(0, chunkSize);
        }
        return groupedThemes;
    }, [calendarPlan.themes_with_periods, groupCount]);

    return (
        <div className={b('calendar-plan')}>
            <div className={b('calendar-plan', 'theme-groups')}>
                {groups.map((themeGroup, index) => (
                    <div className={b('theme-group')} key={index}>
                        <div className={b('theme-group', 'themes')}>
                            {themeGroup.map((theme) => (
                                <CalendarPlanThemeCard
                                    className={b('theme-group', 'theme-card')}
                                    disabled={theme.is_disabled}
                                    key={theme.id}
                                    onThemeNameClick={onThemeClick}
                                    theme={theme}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <UploadPlanButton mix="calendar-plan__upload-plan-button" onClick={onUploadCalendarPlan} />
        </div>
    );
};
